import { Injectable } from '@angular/core';
import { BillingService } from '@core/services/billing.service';
import { DiscountsService } from '@core/services/discounts.service';
import { PremiumService } from '@core/services/premium.service';
import { ProductsService } from '@core/services/products.service';
import { QuoteLetterService } from '@core/services/quote-letter.service';
import { TaskService } from '@core/services/task.service';
import { TelematicsService } from '@core/services/telematics.service';
import { PriceSummaryDisplayContent } from '@app/hub/components/price-summary-display/price-summary-display-content';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { MemberService } from '@core/services/member.service';
import {
  PriceSummaryDisplayContentInputs,
  PriceSummaryUtils,
} from '@shared/utils/hub/price-summary/price-summary.util';
import { ErrorService } from '@entities/error/error.service';
import { DsmService } from '@entities/dsm/dsm.service';
import { Store } from '@ngrx/store';
import { UwIssuesSelectors } from '@core/store/selectors';

@Injectable({
  providedIn: 'root',
})
export class BillingFormService {
  constructor(
    private premiumService: PremiumService,
    private peopleService: MemberService,
    private productsService: ProductsService,
    private billingService: BillingService,
    private quoteLetterService: QuoteLetterService,
    private discountsService: DiscountsService,
    private taskService: TaskService,
    private telematicsService: TelematicsService,
    private errorService: ErrorService,
    private dsmService: DsmService,
    private store: Store
  ) {}

  getPriceSummaryDisplayContentInputs(): Observable<PriceSummaryDisplayContent> {
    return combineLatest([
      this.premiumService.getPremiumsForSelectedProducts(),
      this.peopleService.getPrimaryNamedInsured(),
      this.productsService.getSelectedProducts(),
      this.productsService.getProduct('PersonalUmbrella'),
      this.productsService.getAddOnProducts(),
      this.billingService.getDownPayment(),
      this.productsService.getOverallQuoteStatus(),
      this.quoteLetterService.getQuoteLetter(),
      this.taskService.getIncompleteDraftTasks(),
      this.discountsService.getAppliedPaymentMethodDiscounts(),
      this.telematicsService.isAnyTelematicsEnrolled(),
      this.dsmService.getCallsInFlight(),
      this.errorService.getErrorsWithoutEvtAlerts(),
      this.store.select(UwIssuesSelectors.getUwIssuesByProduct),
      this.productsService.getProduct('DwellingFire'),
    ]).pipe(
      map(
        ([
          premiums,
          pni,
          selectedProducts,
          umbrella,
          addOnProducts,
          downPayment,
          overallQuoteStatus,
          quoteLetterBase64,
          draftTasks,
          paymentMethodDiscounts,
          telematicsPresent,
          callsInFlight,
          errors,
          uwIssues,
          dwellingFire,
        ]: // tslint:disable-next-line:no-any // it's a bit too much type
        any) =>
          PriceSummaryUtils.getPriceSummaryDisplayContent({
            premiums,
            pni,
            selectedProducts,
            umbrella,
            addOnProducts,
            downPayment,
            overallQuoteStatus,
            quoteLetterBase64,
            draftTasks,
            paymentMethodDiscounts,
            telematicsPresent,
            callsInFlight,
            errors,
            uwIssues,
            dwellingFire,
          } as PriceSummaryDisplayContentInputs)
      )
    );
  }
}
